import { Action, Reducer } from "redux";
import { ModelState, ModelTypes, ModelActionTypes } from "./modelTypes";
import {
	haskeyReducer,
	resetIsolatedReducer,
	updateGetIsolated,
	updateSaveIsolated,
} from "@/main/services/reducerUtils";

export const INITIAL_STATE: ModelState = {
	models: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const modelReducer: Reducer<ModelState> = (state: ModelState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as ModelActionTypes;
	switch (actionTypes.type) {
		case ModelTypes.GET_MODELS: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				models: { ...state.models, isLoading: true },
			};
		}
		case ModelTypes.SAVE_MODELS: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				models: {
					...state.models,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case ModelTypes.RESET_REDUCER_MODELS: {
			const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

			return {
				...state,
				models: INITIAL_STATE.models,
			};
		}
		default:
			return state;
	}
};

export default modelReducer;
